import { mapActions } from 'vuex';
import { $EventBus } from '@/main';
import AnnexRegistration from '@/components/agreement/elements/AnnexRegistration/AnnexRegistration.vue';
import SupplierSearch from '@/components/agreement/elements/SupplierSearch/SupplierSearch.vue';

export default {
	name: 'CreateContract',
	data: () => ({
		valid: true,
		loading: false,
		mode: 'CREATE',
		createdId: null,
		form: {
			name: null,
			start_date: null,
			end_date: null,
			owner: null,
		},
		annexes: [],
		requiredRule: [(v) => !!v || 'Campo requerido'],
	}),
	computed: {
		breadcrumbs() {
			return [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'Dashboard' },
				},
				{
					text: 'Abastecimiento',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'AgreementHome' },
				},
				{
					text: 'Nuevo',
					disabled: true,
					href: '/',
				},
			];
		},
		startDateRules() {
			return [
				(v) => !!v || 'Campo requerido',
				(v) =>
					!this.form.end_date ||
					v < this.form.end_date ||
					'La fecha debe ser menor a la fecha de término',
			];
		},
		endDateRules() {
			return [
				(v) => !!v || 'Campo requerido',
				(v) =>
					!this.form.start_date ||
					v > this.form.start_date ||
					'La fecha debe ser mayor a la fecha de inicio',
			];
		},
	},
	methods: {
		...mapActions('supply', ['createSupply']),
		async saveSupply() {
			if (!this.$refs.form.validate()) {
				$EventBus.$emit('showSnack', 'warning', 'Completar formulario');
				return;
			}
			if (this.annexes.length === 0) {
				$EventBus.$emit('showSnack', 'warning', 'Debe agregar al menos un documento');
				return;
			}
			this.loading = true;

			const formData = new FormData();
			formData.append(
				'supply',
				JSON.stringify({
					name: this.form.name,
					start_date: this.form.start_date,
					end_date: this.form.end_date,
					owner_id: this.form.owner?.id,
					company_id: parseInt(localStorage.getItem('company_id')),
				})
			);

			const annexMeta = this.annexes.map((annex) => ({
				name: annex.name,
				type: annex.type,
			}));
			formData.append('supply_documents', JSON.stringify(annexMeta));

			this.annexes.forEach((annex, index) => {
				if (annex.file) {
					formData.append(`document_files[${index}]`, annex.file, annex.file.name);
				}
			});

			const { ok, response, error } = await this.createSupply(formData);
			if (ok) {
				this.createdId = response?.data?.id || null;
				this.mode = 'SAVED';
			} else {
				let msm = error?.data?.message;
				msm = Array.isArray(msm) ? msm.join('<br> ') : msm;
				$EventBus.$emit('showSnack', 'error', msm);
			}
			this.loading = false;
		},
		resetForm() {
			this.form = { name: null, start_date: null, end_date: null, owner: null };
			this.annexes = [];
			this.createdId = null;
			this.mode = 'CREATE';
			this.$nextTick(() => this.$refs.form?.resetValidation());
		},
	},
	components: {
		AnnexRegistration,
		SupplierSearch,
	},
};
